// Preserve transport metadata for retry reconciliation, without showing raw
// authenticated URLs, stack traces or the unhelpful Axios "Network Error".
export function studioRequestError(error, stage, recovery) {
  if (error?.studioStage) return error;
  const status = error?.response?.status || error?.status;
  const message = error?.response?.data?.error?.message || error?.response?.data?.message;
  const serverMessage = typeof message === 'string' ? message.slice(0, 500).replace(/https?:\/\/\S+|\bBearer\s+\S+/gi, '[request details omitted]') : '';
  let detail;
  if (error?.code === 'ERR_CANCELED' || error?.name === 'AbortError') detail = 'The transfer was stopped.';
  else if (error?.code === 'UPLOAD_ETAG_UNAVAILABLE') detail = 'Storage did not expose the uploaded part ETag. Check storage CORS before retrying.';
  else if (status === 401) detail = 'Sign in again, then retry.';
  else if (status === 403) detail = 'Access was refused. ' + (serverMessage || 'Check your account or storage permissions.');
  else if (status === 429) detail = 'Too many requests. Wait a minute before retrying.';
  else if (status === 503) detail = 'The Studio service is temporarily unavailable (HTTP 503). Keep this tab open and retry when service resumes.';
  else if (status === 502 || status === 504) detail = `The Studio gateway could not reach the service (HTTP ${status}). The request outcome is not confirmed.`;
  else if (status >= 500) detail = `The service returned HTTP ${status}.`;
  else if (status) {
    detail = serverMessage || `The request returned HTTP ${status}.`;
  }
  else if (['ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)) detail = 'The request timed out; its result is not confirmed.';
  else detail = 'No response was received. Check your connection; the browser may have blocked the API request.';
  return Object.assign(new Error(`${stage}: ${detail} ${recovery}`), {
    cause: error, response: error?.response, code: error?.code, studioStage: stage,
  });
}
